import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";

export default function PrivacidadePage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-3xl mx-auto px-4 md:px-6 py-10">
        <h1 className="text-2xl md:text-3xl font-bold text-text">Política de Privacidade</h1>
        <p className="text-sm text-gray-500 mt-1">Última atualização: 1º de junho de 2026 · Em conformidade com a LGPD (Lei nº 13.709/2018).</p>

        <Secao n="1" titulo="Quem é o controlador dos dados">
          O tratamento de dados é realizado pelo projeto <b>eaiRH</b>. Contato do responsável / Encarregado (DPO):
          <b> contato@eairh.com.br</b>. Você pode usar este canal para exercer seus direitos de titular.
        </Secao>

        <Secao n="2" titulo="Quais dados coletamos">
          <ul className="list-disc pl-5 space-y-1">
            <li><b>Cadastro:</b> nome, e-mail e, opcionalmente, WhatsApp.</li>
            <li><b>Conteúdo:</b> relatos de processos seletivos, avaliações, interações e (opcional) currículo e anexos.</li>
            <li><b>Empresa (contas de empresa):</b> dados públicos do perfil da empresa.</li>
            <li><b>Técnicos:</b> dados mínimos de funcionamento (ex.: registro de acesso/logs e preferências salvas no navegador).</li>
          </ul>
        </Secao>

        <Secao n="3" titulo="Para que usamos (finalidades)">
          <ul className="list-disc pl-5 space-y-1">
            <li>Operar a plataforma: publicar relatos, calcular reputação e permitir o direito de resposta.</li>
            <li>Autenticar sua conta e permitir a recuperação/confirmação de e-mail.</li>
            <li>Enviar notificações que <b>você autorizou</b> (e-mail/WhatsApp), por canal.</li>
            <li>Fazer o "match" entre vagas e currículos, quando você usa essa função.</li>
            <li>Moderar conteúdo e prevenir abusos/fraudes.</li>
          </ul>
        </Secao>

        <Secao n="4" titulo="Base legal (LGPD)">
          Tratamos seus dados com base em: <b>consentimento</b> (ex.: notificações por canal), <b>execução de contrato</b>
          (prestação do serviço que você solicitou) e <b>legítimo interesse</b> (segurança, moderação e melhoria da
          plataforma), sempre respeitando seus direitos.
        </Secao>

        <Secao n="5" titulo="Consentimento por canal e comunicação intermediada">
          As notificações por e-mail e WhatsApp são <b>opt-in</b> — você escolhe receber, e pode desativar a qualquer
          momento em "Minha conta". Toda comunicação entre candidato e empresa passa <b>pela plataforma</b>; não
          entregamos seu contato direto à outra parte sem consentimento.
        </Secao>

        <Secao n="6" titulo="Compartilhamento de dados">
          <b>Não vendemos seus dados.</b> Podemos utilizar provedores estritamente para operar o serviço, nas finalidades
          aqui descritas: <b>hospedagem</b>, <b>envio de e-mail</b> e um provedor de <b>inteligência artificial</b> (Anthropic — Claude).
          Conteúdo que você publica (relatos) é, por natureza, <b>público</b> na plataforma — por isso recomendamos não
          incluir dados sensíveis seus ou de terceiros.
        </Secao>

        <Secao n="6.1" titulo="Uso de Inteligência Artificial (IA)">
          De forma <b>opcional</b>, usamos um provedor de IA (Anthropic/Claude) para: (a) <b>ler currículos enviados</b> e
          pré-preencher seu perfil e (b) responder no <b>assistente virtual</b>. Nessas funções, o <b>texto que você envia</b>
          (currículo ou mensagem do chat) é processado por esse provedor, que pode estar localizado <b>no exterior</b>
          (ver seção 13). Esse processamento serve apenas para gerar a resposta/extração solicitada por você. Os recursos
          de IA podem ser <b>desativados</b>, e você não é obrigado(a) a usá-los.
        </Secao>

        <Secao n="7" titulo="Dados de terceiros nos relatos">
          Ao relatar, <b>não inclua dados pessoais de terceiros</b> (nome completo, telefone ou e-mail de recrutadores).
          O foco deve ser a conduta da empresa. Dados de contato de pessoas envolvidas, quando informados em campos
          privados, são tratados como confidenciais e <b>não exibidos publicamente</b>.
        </Secao>

        <Secao n="8" titulo="Cookies e armazenamento local">
          Usamos armazenamento local do navegador (ex.: token de login, preferências como o registro de "Útil" e o
          histórico recente do assistente virtual) para o funcionamento da plataforma — esses dados ficam <b>no seu
          navegador</b>. Não usamos cookies de publicidade.
        </Secao>

        <Secao n="9" titulo="Segurança">
          <ul className="list-disc pl-5 space-y-1">
            <li>Senhas são armazenadas com <b>hash</b> (não reversível) — ninguém consegue ler sua senha.</li>
            <li>O acesso é feito por <b>HTTPS</b>.</li>
            <li>Dados de contato de terceiros são <b>mascarados</b> no perfil público.</li>
          </ul>
        </Secao>

        <Secao n="10" titulo="Seus direitos (titular dos dados)">
          Você pode, a qualquer momento: <b>acessar, corrigir, atualizar e exportar</b> seus dados; <b>revogar
          consentimento</b>; <b>se opor</b> a determinado tratamento; e <b>excluir</b> seus dados. <b>Correção,
          atualização e revogação de consentimento</b> (preferências de notificação) podem ser feitas diretamente em
          <b>"Minha conta"</b>. Para <b>exportação ou exclusão</b> dos seus dados, escreva para
          <b> contato@eairh.com.br</b> — atendemos sua solicitação conforme a LGPD.
        </Secao>

        <Secao n="11" titulo="Retenção e exclusão">
          Mantemos seus dados enquanto sua conta existir ou conforme necessário para as finalidades acima. Ao solicitar
          a exclusão, removemos seus dados pessoais; relatos podem ser anonimizados (desvinculados da sua identidade)
          para preservar o histórico público de reputação, salvo solicitação de remoção do conteúdo.
        </Secao>

        <Secao n="12" titulo="Menores de idade">
          A plataforma é destinada a maiores de 18 anos. Não coletamos intencionalmente dados de menores.
        </Secao>

        <Secao n="13" titulo="Hospedagem e transferência internacional">
          A plataforma pode ser hospedada em provedores localizados fora do Brasil. Nesses casos, buscamos garantir
          padrões de proteção compatíveis com a LGPD.
        </Secao>

        <Secao n="14" titulo="Alterações desta Política">
          Esta Política pode ser atualizada. Mudanças relevantes serão comunicadas na plataforma.
        </Secao>

        <Secao n="15" titulo="Contato e Encarregado (DPO)">
          Para dúvidas sobre privacidade ou para exercer seus direitos: <b>contato@eairh.com.br</b>.
        </Secao>

        <div className="mt-8 text-sm">
          <Link to="/termos" className="text-primary font-semibold hover:underline">Ver Termos de Uso →</Link>
        </div>
      </main>
    </div>
  );
}

function Secao({ n, titulo, children }) {
  return (
    <section className="mt-6">
      <h2 className="text-lg font-bold text-gray-900">{n}. {titulo}</h2>
      <div className="mt-2 text-sm text-gray-700 leading-relaxed">{children}</div>
    </section>
  );
}
